import IpsIcon from './IpsIcon.vue';
import '../../../styles/custom.scss';

export default IpsIcon;
